@if (isVisible()) {
  @if (route()) {
    <a
      [routerLink]="route()"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: exact() }"
      class="nav-btn"
    >
      <svg [lucideIcon]="icon()"></svg>
      <span>{{ label() }}</span>
    </a>
  } @else {
    <button class="nav-btn" (click)="action.emit()">
      <svg [lucideIcon]="icon()"></svg>
      <span>{{ label() }}</span>
    </button>
  }
}
